import { Helmet } from "react-helmet-async";
import { env } from "~/env";

export const generateRoutesWithTitle = (routes) =>
  routes.map((route) => ({
    path: route.path,
    Component: () => {
      const fullTitle = `${route.title} - ${env.VITE_MFO_NAME_SHORT}`;
      return (
        <>
          <Helmet title={route.title}>
            <meta name="title" content={fullTitle} />
            {route.description && (
              <meta name="description" content={route.description} />
            )}
          </Helmet>
          {route.element}
        </>
      );
    },
    loader: route.loader,
    children: route.children && generateRoutesWithTitle(route.children),
  }));
